import { takeEvery, call, put, select } from 'redux-saga/effects'
import actionTypes from '_constants/actionTypes'
import { xcService } from '_services/xcService'

export default function* watcherData() {
  yield takeEvery(actionTypes.GET_COUNTRIES, getCountries)
  yield takeEvery(actionTypes.GET_PROVINCES, getProvinces)
  yield takeEvery(actionTypes.GET_CITIES, getCities)
  yield takeEvery(actionTypes.GET_COURSES, getCourses)
  yield takeEvery(actionTypes.GET_PROFESSIONS, getProfessions)

  yield takeEvery(actionTypes.GET_PROVINCESCOUNTRY, getProvincesCountry)
  

}



function* getProvincesCountry({payload}) {
  yield put({ type: actionTypes.START_REQUEST })

  try {
    let apiEndpoint = '/v1/provinces/'+payload
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.get(apiEndpoint, null).then((response) => {
            resolve(response)
          })
        }),
    )
    if (res.status === 200) {
      yield put({ type: actionTypes.GET_PROVINCES_DATA, payload: res.data.data })
    } else {
      yield put({ type: actionTypes.GET_PROVINCES_ERROR, payload: res.data })
    }
  } catch (e) {
    yield put({ type: actionTypes.GET_PROVINCES_ERROR, payload: e })
  }
  yield put({ type: actionTypes.END_REQUEST })
}


function* getCourses() {
  yield put({ type: actionTypes.START_REQUEST })

  try {
    let apiEndpoint = '/v1/courses'
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.get(apiEndpoint, null).then((response) => {
            resolve(response)
          })
        }),
    )
    if (res.status === 200) {
      yield put({ type: actionTypes.GET_COURSES_DATA, payload: res.data.data })
    } else {
      yield put({ type: actionTypes.GET_COURSES_ERROR, payload: res.data })
    }
  } catch (e) {
    yield put({ type: actionTypes.GET_COURSES_ERROR, payload: e })
  }
  yield put({ type: actionTypes.END_REQUEST })
}

function* getCountries() {
  yield put({ type: actionTypes.START_REQUEST })

  try {
    let apiEndpoint = '/v1/countries'
    const res = yield call(
      () =>
        new Promise((resolve, reject) => {
          xcService.get(apiEndpoint, null).then((response) => {
            resolve(response)
          })
        }),
    )
    if (res.status === 200) {
      yield put({ type: actionTypes.GET_COUNTRIES_DATA, payload: res.data.data })
    } else {
      yield put({ type: actionTypes.GET_COUNTRIES_ERROR, payload: res.data })
    }
  } catch (e) {
    yield put({ type: actionTypes.GET_COUNTRIES_ERROR, payload: e })
  }
  yield put({ type: actionTypes.END_REQUEST })
}


function* getProvinces() {
    yield put({ type: actionTypes.START_REQUEST })
  
    try {
      let apiEndpoint = '/v1/provinces'
      const res = yield call(
        () =>
          new Promise((resolve, reject) => {
            xcService.get(apiEndpoint, null).then((response) => {
              resolve(response)
            })
          }),
      )
      if (res.status === 200) {
        yield put({ type: actionTypes.GET_PROVINCES_DATA, payload: res.data.data })
      } else {
        yield put({ type: actionTypes.GET_PROVINCES_ERROR, payload: res.data })
      }
    } catch (e) {
      yield put({ type: actionTypes.GET_PROVINCES_ERROR, payload: e })
    }
    yield put({ type: actionTypes.END_REQUEST })
  }

function* getCities() {
    yield put({ type: actionTypes.START_REQUEST })
  
    try {
      let apiEndpoint = '/v1/cities'
      const res = yield call(
        () =>
          new Promise((resolve, reject) => {
            xcService.get(apiEndpoint, null).then((response) => {
              resolve(response)
            })
          }),
      )
      if (res.status === 200) {
        yield put({ type: actionTypes.GET_CITIES_DATA, payload: res.data.data })
      } else {
        yield put({ type: actionTypes.GET_CITIES_ERROR, payload: res.data })
      }
    } catch (e) {
      yield put({ type: actionTypes.GET_CITIES_ERROR, payload: e })
    }
    yield put({ type: actionTypes.END_REQUEST })
  }

  function* getProfessions() {
    yield put({ type: actionTypes.START_REQUEST })
  
    try {
      let apiEndpoint = '/v1/professions/'
      const res = yield call(
        () =>
          new Promise((resolve, reject) => {
            xcService.get(apiEndpoint, null).then((response) => {
              resolve(response)
            })
          }),
      )
      if (res.status === 200) {
        yield put({ type: actionTypes.GET_PROFESSIONS_DATA, payload: res.data.data })
      } else {
        yield put({ type: actionTypes.GET_PROFESSIONS_ERROR, payload: res.data })
      }
    } catch (e) {
      yield put({ type: actionTypes.GET_PROFESSIONS_ERROR, payload: e })
    }
    yield put({ type: actionTypes.END_REQUEST })
  }